/* eslint-disable */
import { combineReducers } from "redux";
import Actions from "./action-types";
import { FlowStatus } from "./constants";
import {
  buildTreatmentData,
  deleteTreatmentData,
  updateTreatmentData
} from "../utils/treatment-data-builder";
import {
  buildProviderList,
  buildFilterString
} from "../utils/provider-list-builder";
import { filterObjectWithEntries } from "../utils/object-helper";

const {
  ASSESMENT_CHANGED,
  RESET_ASSESMENTS,
  FETCH_FLOW,
  FETCH_FAIL,
  NEXT_SCREEN,
  PREV_SCREEN,
  PREV_SCREEN_SUCCESS,
  PREV_SCREEN_FAILED,
  FIELD_CHANGED,
  SHOW_GLOBAL_DIALOG,
  INITIALIZE_FLOW,
  INITIALIZE_SCREEN,
  INITIALIZE_SCREEN_PREV,
  PHARMACIES_FOUND,
  CAPSULE_PHARMACY_FOUND,
  PICK_PHARMACY_ON_MAP,
  SET_FILTERS,
  RESET_FILTERS,
  SET_DETAIL_PROVIDER_DATA,
  RESET_DETAIL_PROVIDER_DATA,
  SET_DETAIL_PROVIDER_FIELDS_DATA,
  CARE_TEAM_SET_DETAIL_PROVIDER_FIELDS_DATA,
  SET_TREATMENT_DATA,
  DELETE_TREATMENT_DATA,
  UPDATE_TREATMENT_DATA,
  RESET_TREATMENT_DATA,
  SET_TREATMENT_TO_EDIT,
  RESET_TREATMENT_TO_EDIT,
  RESET_STATE,
  SET_STATE,
  DELETE_FROM_STATE,
  RESET_STORE,
  SET_VALIDATION,
  RESET_VALIDATION,
  ADD_TOAST,
  REMOVE_TOAST,
  SET_CONSULT_STATE,
  UPDATE_HISTORY,
  UPDATE_HISTORY_ACTION,
  SET_FIELD_VALIDATION,
  RESET_FIELD_VALIDATION,
  RESET_FIELDS_VALIDATION,
  RESET_FIELD_VALIDATION_ALL,
  DEPENDENT_STORED_SUCCESS,
  RESET_DEPENDENT,
  CARE_RECIPIENT_STORED_SUCCESS,
  RESET_CARE_RECIPIENT,
  ADD_TRACKING_EVENT,
  RESET_TRACKING_EVENTS,
  SET_SCREEN_PARAMS,
  SET_FORM_GROUP_ERRORS,
  FETCH_AVAILABLE_TIMES_PENDING,
  FETCH_AVAILABLE_TIMES_SUCCESS,
  FETCH_AVAILABLE_TIMES_FAILURE,
  SET_SELECTED_DATE,
  SET_SELECTED_TIME,
  CLEAR_DATE_TIME_SELECTION,
  ADD_CALL_TO_ACTION_BUTTON_IS_LOADING,
  REMOVE_CALL_TO_ACTION_BUTTON_IS_LOADING,
  LOADING,
  SET_SHOW_HUD,
  RESET_SHOW_HUD,
  SET_SETTINGS,
  INITIALIZE_DIALOG,
  CLEAR_DIALOG_FLOW,
  RESET_ACTION_FIELD,
  SET_FORM_ERRORS_FROM_BACK,
  PII_COLLECTED_SUCCESS,
  SET_PAGE_NUMBER,
  SET_SELECTED_LIST_ITEM,
  RESET_FORM_FIELDS,
  ITEM_SELECTED,
  RESET_ITEM_SELECTED,
  LOADED
} = Actions;

export const data = (state = null, { type, payload }) => {
  switch (type) {
    case INITIALIZE_FLOW:
      return payload.data;
    case PREV_SCREEN_SUCCESS:
      return payload.data;
    case RESET_STORE:
      return null;
    case SET_FORM_ERRORS_FROM_BACK:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export const screenParams = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_SCREEN_PARAMS:
      return { ...state, ...payload };
    case SHOW_GLOBAL_DIALOG:
    case NEXT_SCREEN:
    case INITIALIZE_FLOW:
      return { ...state, ...payload.screenParams };
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

export const history = (state = [], { type, payload }) => {
  switch (type) {
    case INITIALIZE_FLOW:
      const initialScreenIndex = Math.max(
        payload.data.screens.findIndex(s => s.name === payload.initialScreen),
        0
      );
      const {
        identifier,
        name,
        params,
        data: localData = {},
        hiddenFields: { return_back_url: returnBackURL }
      } = payload.data.screens[initialScreenIndex];
      const { reloadPageAction } = localData;
      const newHistoryItem = {
        url: payload.url,
        index: initialScreenIndex,
        identifier,
        name,
        params,
        formState: { ...payload.formState },
        reloadPageAction,
        isInitialScreen: true,
        returnBackURL
      };
      const replaceHistory = !payload.isPageReloaded
        ? payload.replaceHistory
        : 1;

      if (returnBackURL || payload.url === "screens/unified_profile") {
        return [newHistoryItem];
      } else if (
        payload.url ===
          "/screens/medical_info/vitals/blood_pressure/added_measurements" ||
        payload.url ===
          "/screens/medical_info/vitals/heart_rate/added_measurements" ||
        state[0]?.params?.includes("TDScreenOptionActionDismiss")
      ) {
        // pass 1 to remove first history object(add br/hr measurement form screen)
        return [...state.slice(1)];
      } else {
        return [newHistoryItem, ...state.slice(replaceHistory)];
      }
    case NEXT_SCREEN:
      return [
        {
          url: state[0].url,
          index: payload.nextIndex,
          identifier: payload.nextScreenIdentifier,
          name: payload.nextScreenName,
          formState: { ...payload.formState },
          reloadPageAction: payload.reloadPageAction
        },
        ...state.slice(payload.replaceHistory)
      ];
    case PREV_SCREEN_SUCCESS:
      return state.slice(payload.count);
    case RESET_STATE:
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

export const lastNavAction = (state = "next", { type }) => {
  switch (type) {
    case INITIALIZE_FLOW:
      return "next";
    case PREV_SCREEN_SUCCESS:
      return "back";
    case RESET_STORE:
      return "next";
    default:
      return state;
  }
};

export const screenInitialized = (state = false, { type }) => {
  switch (type) {
    case INITIALIZE_FLOW:
    case NEXT_SCREEN:
    case PREV_SCREEN_SUCCESS:
      return false;
    case INITIALIZE_SCREEN:
    case INITIALIZE_SCREEN_PREV:
      return true;
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

export const flowStatus = (state = FlowStatus.LOADING, { type, payload }) => {
  switch (type) {
    case FETCH_FLOW:
    case PREV_SCREEN:
    case LOADING:
      return FlowStatus.LOADING;
    case INITIALIZE_FLOW:
    case LOADED:
    case PREV_SCREEN_SUCCESS:
      return FlowStatus.LOADED;
    case FETCH_FAIL:
    case PREV_SCREEN_FAILED:
      return FlowStatus.ERROR;
    case SHOW_GLOBAL_DIALOG:
      return payload?.screenParams?.dialogConfig ? FlowStatus.LOADED : state;
    case RESET_STORE:
      return FlowStatus.LOADING;
    default:
      return state;
  }
};

export const initialValidationState = {
  valid: true,
  fieldName: "",
  message: ""
};

export const validation = (
  state = initialValidationState,
  { type, payload }
) => {
  switch (type) {
    case SET_VALIDATION:
      return {
        valid: false,
        fieldName: payload.fieldName,
        message: payload.message
      };
    case RESET_VALIDATION:
    case RESET_STORE:
      return { ...initialValidationState };
    default:
      return state;
  }
};

export const fieldValidation = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_FIELD_VALIDATION:
      return { ...state, ...payload };
    case RESET_FIELD_VALIDATION:
      return Object.fromEntries(
        Object.entries(state).filter(([fieldName]) => fieldName !== payload)
      );
    case RESET_FIELDS_VALIDATION:
      return {};
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

export const toasts = (state = [], { type, payload }) => {
  switch (type) {
    case ADD_TOAST:
      return [...state.filter(toast => toast.id !== payload.id), payload];
    case REMOVE_TOAST:
      return state.filter(toast => toast.id !== payload);
    case FETCH_FLOW:
    case NEXT_SCREEN:
    case PREV_SCREEN:
      return [];
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

export const formState = (state = {}, { type, payload }) => {
  switch (type) {
    case FIELD_CHANGED:
      return { ...state, ...payload };
    case INITIALIZE_FLOW:
      return {
        ...payload.formState,
        ...payload.data.hidden_fields
      };
    case CLEAR_DIALOG_FLOW:
      return payload?.resettable ? payload.formState : state;
    case INITIALIZE_SCREEN:
      return { ...state, ...payload };
    case INITIALIZE_SCREEN_PREV:
      return { ...state, ...payload };
    case NEXT_SCREEN:
      return payload.formState;
    case SET_STATE:
      return { ...payload };
    case DELETE_FROM_STATE:
      return filterObjectWithEntries(state, payload);
    case RESET_ACTION_FIELD:
      const newFormState = {
        ...state
      };
      delete newFormState[payload];
      return newFormState;
    case RESET_FORM_FIELDS:
      return {
        date: payload,
        logged_in_member_id: state.logged_in_member_id,
        measurement_type: state.measurement_type
      };
    case PREV_SCREEN_SUCCESS:
      return {
        ...state,
        ...payload?.data?.hidden_fields
      };
    case RESET_STATE:
      return {};
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

export const assesmentsState = (state = {}, { type, payload }) => {
  switch (type) {
    case ASSESMENT_CHANGED:
      return { ...state, ...payload };
    case RESET_ASSESMENTS:
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};
const pharmacies = (
  state = { all: [], selected: null },
  { type, payload = [] }
) => {
  switch (type) {
    case PHARMACIES_FOUND:
      return { all: payload, selected: null };
    case PICK_PHARMACY_ON_MAP:
      return { ...state, selected: payload };
    case RESET_STORE:
      return { all: [], selected: null };
    default:
      return state;
  }
};

const capsuleDelivery = (
  state = { isDeliverable: false },
  { type, payload }
) => {
  switch (type) {
    case CAPSULE_PHARMACY_FOUND:
      return { isDeliverable: true, ...payload };
    default:
      return state;
  }
};

const providerFilters = (
  state = {
    filters: {},
    providers: { all: [], filtered: [] },
    filterString: "",
    previousProviders: []
  },
  { type, filters, providersList }
) => {
  switch (type) {
    case RESET_STORE:
      return {
        filters: {},
        providers: { all: [], filtered: [] },
        filterString: "",
        previousProviders: []
      };
    case SET_FILTERS:
      return {
        filters: {
          ...state.filters,
          ...filters
        },
        providers: {
          all: providersList || state.providers.all,
          filtered: buildProviderList(state.providers.all, {
            ...state.filters,
            ...filters,
            ...state.previousProviders
          })
        },
        filterString: buildFilterString({
          ...state.filters,
          ...filters
        }),
        previousProviders: {
          ...state.previousProviders
        }
      };
    case RESET_FILTERS:
      return {
        filters: {
          can_prescribe: null,
          gender: [],
          languages: [],
          provider_specialties: []
        },
        providers: {
          all: state.providers.all,
          filtered: buildProviderList(state.providers.all, {})
        },
        filterString: "",
        previousProviders: {
          ...state.previousProviders
        }
      };
    default:
      return state;
  }
};

const providerDetailData = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_DETAIL_PROVIDER_DATA:
      return {
        ...payload
      };
    case RESET_DETAIL_PROVIDER_DATA:
      return {};
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

const providerDetailFieldsData = (state = [], { type, payload }) => {
  switch (type) {
    case SET_DETAIL_PROVIDER_FIELDS_DATA:
      return payload;
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

const careTeamProviderDetailFieldsData = (state = [], { type, payload }) => {
  switch (type) {
    case CARE_TEAM_SET_DETAIL_PROVIDER_FIELDS_DATA:
      return payload;
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

const dermTreatmentData = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_TREATMENT_DATA:
      return buildTreatmentData(payload, state);
    case DELETE_TREATMENT_DATA:
      return deleteTreatmentData(payload, state);
    case UPDATE_TREATMENT_DATA:
      return updateTreatmentData(payload, state);
    case RESET_TREATMENT_DATA:
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

const treatmentToEditData = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_TREATMENT_TO_EDIT:
      return {
        ...payload
      };
    case RESET_TREATMENT_TO_EDIT:
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

const consultStatus = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_CONSULT_STATE:
      return {
        ...payload
      };
    case RESET_STORE:
      return {};
    default:
      return state;
  }
};

export const dependentStored = (state = false, { type }) => {
  switch (type) {
    case DEPENDENT_STORED_SUCCESS:
      return true;
    case RESET_DEPENDENT:
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

export const careRecipientStored = (state = false, { type }) => {
  switch (type) {
    case CARE_RECIPIENT_STORED_SUCCESS:
      return true;
    case RESET_CARE_RECIPIENT:
      return false;
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

const screensHistoryFlow = (state = [], { type, payload }) => {
  switch (type) {
    case UPDATE_HISTORY:
      return [...state, payload];
    case UPDATE_HISTORY_ACTION:
      const updatedState = [...state];
      updatedState[payload.index].action = payload.action;
      return [...updatedState];
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

const trackingEvents = (state = [], { type, payload }) => {
  switch (type) {
    case ADD_TRACKING_EVENT:
      return [...state, payload];
    case RESET_TRACKING_EVENTS:
    case RESET_STORE:
      return [];
    default:
      return state;
  }
};

const formGroupErrors = (state = [], { type, payload }) => {
  switch (type) {
    case SET_FORM_GROUP_ERRORS:
      return [...payload];
    case RESET_FIELD_VALIDATION_ALL:
      return [];
    default:
      return state;
  }
};

const initiaDateTimeState = {
  selectedDate: "",
  selectedTime: "",
  error: "",
  availableTimes: [],
  isLoading: false,
  isLoaded: false
};

const dateTimeSelection = (state = initiaDateTimeState, { type, payload }) => {
  switch (type) {
    case INITIALIZE_FLOW:
      return initiaDateTimeState;
    case FETCH_AVAILABLE_TIMES_PENDING:
      return {
        ...state,
        selectedTime: "",
        availableTimes: [],
        error: "",
        isLoading: true
      };
    case FETCH_AVAILABLE_TIMES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        availableTimes: [...payload.availableTimes]
      };
    case FETCH_AVAILABLE_TIMES_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: payload.error
      };
    case SET_SELECTED_DATE:
      return {
        ...state,
        selectedDate: payload.selectedDate
      };
    case SET_SELECTED_TIME:
      return {
        ...state,
        selectedTime: payload.selectedTime
      };
    case CLEAR_DATE_TIME_SELECTION:
      return {
        ...initiaDateTimeState
      };
    default:
      return state;
  }
};

const callToActionButtonInitialState = {
  isLoading: []
};

const callToActionButton = (
  state = callToActionButtonInitialState,
  { type, payload }
) => {
  switch (type) {
    case ADD_CALL_TO_ACTION_BUTTON_IS_LOADING:
      return { isLoading: [...state.isLoading, payload] };
    case REMOVE_CALL_TO_ACTION_BUTTON_IS_LOADING:
      return {
        isLoading: state.isLoading.filter(button => button !== payload)
      };
    default:
      return state;
  }
};

export const showHud = (state = false, { type }) => {
  switch (type) {
    case SET_SHOW_HUD:
      return true;
    case RESET_SHOW_HUD:
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

export const dialogInitialized = (state = false, { type }) => {
  switch (type) {
    case INITIALIZE_DIALOG:
      return true;
    case CLEAR_DIALOG_FLOW:
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

export const settings = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_SETTINGS:
      return payload;
    default:
      return state;
  }
};

export const isGlobalDialogShown = (state = false, { type, payload }) => {
  switch (type) {
    case SHOW_GLOBAL_DIALOG:
      return !!payload?.screenParams?.dialogConfig;
    default:
      return state;
  }
};

export const isPiiCollected = (state = false, { type }) => {
  switch (type) {
    case PII_COLLECTED_SUCCESS:
      return true;
    case RESET_STORE:
      return false;
    default:
      return state;
  }
};

const pageNumber = (state = 1, { type, payload }) => {
  switch (type) {
    case SET_PAGE_NUMBER:
      return payload.pageNumber;
    case INITIALIZE_FLOW:
    case PREV_SCREEN_SUCCESS:
      return 1;
    default:
      return state;
  }
};

const selectedListItem = (state = null, { type, payload }) => {
  switch (type) {
    case SET_SELECTED_LIST_ITEM:
      return { ...payload };
    case RESET_STORE:
    case INITIALIZE_FLOW:
    case PREV_SCREEN_SUCCESS:
      return null;
    default:
      return state;
  }
};

const isItemSelected = (state = false, { type, payload }) => {
  switch (type) {
    case ITEM_SELECTED:
      return payload;
    case RESET_ITEM_SELECTED:
      return false;
    default:
      return false;
  }
};

export default combineReducers({
  data,
  screenParams,
  flowStatus,
  history,
  lastNavAction,
  screenInitialized,
  formState,
  assesmentsState,
  validation,
  fieldValidation,
  toasts,
  pharmacies,
  providerFilters,
  consultStatus,
  providerDetailData,
  providerDetailFieldsData,
  careTeamProviderDetailFieldsData,
  dermTreatmentData,
  treatmentToEditData,
  dependentStored,
  screensHistoryFlow,
  careRecipientStored,
  trackingEvents,
  formGroupErrors,
  showHud,
  settings,
  dialogInitialized,
  isGlobalDialogShown,
  dateTimeSelection,
  callToActionButton,
  isPiiCollected,
  pageNumber,
  selectedListItem,
  isItemSelected,
  capsuleDelivery
});
